// Autofill otherwise paints the browser's own background over the raised surface.
export const authFieldClassName =
  "h-11 min-w-0 [--auth-field-background:oklch(from_var(--color-surface)_l_0_h)] bg-[var(--auth-field-background)] [&_input:-webkit-autofill]:[-webkit-text-fill-color:var(--color-default)] [&_input:-webkit-autofill]:shadow-[inset_0_0_0_1000px_var(--auth-field-background)] [&[aria-invalid=true]_input:-webkit-autofill]:shadow-[inset_0_0_0_1000px_var(--color-rose-soft)]";

export const authButtonClassName =
  "cursor-pointer bg-brand-seashell text-sm text-black hover:bg-brand-seashell/90";
